import React from 'react'
import StarRating from './StarRating';
import { FcGoogle } from '@react-icons/all-files/fc/FcGoogle';
import { FaYelp } from '@react-icons/all-files/fa/FaYelp';
import { SiTrustpilot } from '@react-icons/all-files/si/SiTrustpilot';
import Carrousel from './Carrousel';
import reviews from '../utilities/clientReviews';
import PicCont from './PicCont';
import * as gtag from '../lib/gtag';
import { useRouter } from 'next/router';
import AudioAction from './design-system/audio/AudioAction';
import ReviewProof from './design-system/marketing/ReviewProof';
import MarketingIsland from './design-system/marketing/MarketingIsland';
const ClientReviews = ({filter, orlando, ui, homepage, initialData, pagePath, heading, description, sectionId}) => {

    let _orlando = Boolean(orlando)
    const { asPath } = useRouter()

  if (ui === 'v2') {
    return <MarketingIsland>
      <ReviewProof
        description={description}
        filter={filter}
        heading={heading || (_orlando
          ? 'Google reviews from Central Florida clients'
          : 'Google reviews from Miami Sound Rental clients')}
        initialData={initialData}
        pagePath={pagePath || asPath?.split('?')[0] || '/'}
        sectionId={sectionId || (homepage ? 'homepage-client-reviews' : 'client-reviews')}
      />
    </MarketingIsland>
  }

  return  <section className='clientReviews'>
  <div className='upperBold'>{_orlando ? `Orlando & Central Florida's #1` :`South Florida's #1`} Rated AV Provider</div>
  <div className="revRow">

    <div className='revSub'>
        <div className="rat"><strong> 5 / 5</strong> <SiTrustpilot id={'green'} /></div>  <StarRating rating={5} />
    </div>
    <div className='revSub'>
        <div className="rat"><strong> 4.9 / 5</strong> <FcGoogle /></div><StarRating rating={5} />
    </div>
    <div className='revSub'>
        <div className="rat"><strong> 5 / 5</strong> <FaYelp id="red" />    </div> <StarRating rating={5} />
    </div>
  </div>

  <p className='subP'>We are doing a great job, but don&apos;t take our word for it. Here is what our clients think:</p>
  <Carrousel ui={ui} size={2} array={reviews.filter(r => filter ? r.tags?.some(t => filter.includes(t)) : true).map((rev, i) => <div key={i} className='revCont'>
      <div className='headRow'>
          <PicCont src={rev.picture} />
          <div className='nameCol'>
              <strong>{rev.name}</strong>
              <span>{rev.date}</span>
          </div>
      </div>
      <StarRating rating={rev.stars} />
      <p>{rev.body}</p>
      {ui === 'v2'
        ? <AudioAction mode='text' href={rev.link} target='_blank'><FcGoogle />Read this review on google</AudioAction>
        : <a href={rev.link} target='_blank' rel='noreferrer' ><FcGoogle />Read this review on google</a>}
  </div>)} />
  <div className='buttons'>
      {ui === 'v2'
        ? <AudioAction mode='primary' onClick={() => gtag.event({ action:  'view_reviews', label: 'leads', value: 1, category: 'orders' })} href='https://search.google.com/local/reviews?placeid=ChIJs3yjQeut2YgRok3VQMIWH2Q' target='_blank'>View All Google Reviews</AudioAction>
        : <a onClick={() => gtag.event({ action:  'view_reviews', label: 'leads', value: 1, category: 'orders' })} className='button btn-5 highLight ' href='https://search.google.com/local/reviews?placeid=ChIJs3yjQeut2YgRok3VQMIWH2Q' target='_blank noreferrer noopener' >View All Google Reviews</a>}
  </div>


</section>
}

export default ClientReviews
